WiseMetering.Views.ShowDataPortalConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/data_portal/show',
    title: () => i18next.t('modal.title.integration_configurations.show'),

    edit: function() {
        new WiseMetering.Views.EditDataPortalConfiguration({ model: this.model });
    },

    // the index never carries the access token: only the show endpoint does, to administrators
    onShow: function() {
        this.model.fetch().done(() => {
            if (this.isClosed) {
                return;
            }

            this.render();
            this.modal.redraw(true);
        });
    }
});
